import React, { createContext, PropsWithChildren, useContext } from 'react';
import NotificationContext from './types/notificationContext';
import useNotification from './hooks/useNotification';
import Notification from 'app/Components/Notification';

export const NotificationContext = createContext<NotificationContext>({
    open: false,
    handleOpen: () => null,
    handleClose: () => null,
    notification: { title: '', message: '', severity: 'info' },
    showNotification: () => null,
});

export const NotificationProvider: React.FC<PropsWithChildren> = ({
    children,
}) => {
    const notificationContextValue = useNotification();

    return (
        <NotificationContext.Provider value={notificationContextValue}>
            <Notification />
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotificationContext = (): NotificationContext =>
    useContext(NotificationContext);
